import { useLocation } from 'react-router';
import core, { App } from '@gin-betting/core';

const {
    utils: { getSportTypeFromLocation },
} = core;

export default function useSportType(): App.SportType {
    useLocation();

    return getSportTypeFromLocation();
}
